import React from "react";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import Curriercompanyeditcontent from "./Curriercompanyeditcontent";

export const Content = (props) => {
  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <Curriercompanyeditcontent/>
        </div>
      </div>
    </div>
  );
};

export default Content;
